export default __webpack_public_path__ + "static/media/heirlooms.bda4be49.pdf";